import { useContext } from 'react';
import { PresenceContext, DEFAULT_PRESENCE } from './PresenceContext.jsx';

/**
 * Returns live presence data from the nearest PresenceProvider.
 * Falls back to a safe default (offline, no WebSocket) when rendered
 * outside a provider (e.g. wexford / teldire / resume subdomains).
 */
export function usePresence() {
  const ctx = useContext(PresenceContext);
  return ctx ?? { presence: DEFAULT_PRESENCE, loading: false };
}
